import React from "react";

export const MyAccountSad: React.FC<DogsTrust.IconProps> = ({
	height = "40px",
	width = "40px",
	fillPrimary = "#222",
	fillSecondary = "#fff",
	invert,
	...props
}) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			width={width}
			height={height}
			viewBox="0 0 99 98"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g filter="url(#icon_ma_sad_svg__a)">
				<path
					fill={invert ? fillSecondary : fillPrimary}
					fillRule="evenodd"
					d="M13.765 31.62C20.557 15.62 35.222 9 52.063 9c23.902 0 36.939 17.93 36.939 40.55C89.002 69.414 73.248 89 52.877 89c-24.987 0-39.112-9.93-43.73-35.587-.814-6.62 1.903-16.552 4.618-21.793"
					clipRule="evenodd"
				/>
			</g>
			<path
				fill={invert ? fillPrimary : fillSecondary}
				fillRule="evenodd"
				d="M57.062 42.197c1.595.461 8.54 2.47 9.161 2.755.686.316.217 1.58.217 1.58s-4.38 18.785-5.524 23.593c.252-.061.595-.106.921-.004.095.03.107.054.12.08.014.029.028.059.136.1.048.018.09.067.13.115.032.039.065.077.1.098.742.422 1.162 1.341.918 1.866-2.377.844-4.508.5-5.37.34l.037.04c.042.045.081.087.062.08-1.304-.459-1.254-1.756-1.225-2.495.005-.131.01-.244.005-.332-.007-.142.052-.943.133-2.064.166-2.285.428-5.898.431-7.95l1.826-2.294-1.67.63-.308.118a4.487 4.487 0 0 1-1.89.29l-4.296-.275s-3.822-.697-9.33-.967c-.043 4.107-4.644 8.045-4.644 8.045l-.224 4.54c.22-.035.476-.04.723.035.094.03.106.054.119.08.013.029.028.059.137.1.031.012.162.05.32.095.285.082.658.19.709.219.743.423 1.255 1.114 1.01 1.64-1.378.488-3.566.705-4.58.662-2.735.01-2.598-1.684-2.598-1.684s.16-8.004-.421-11.974c-.581-3.97-1.475-8.888-1.836-9.744-6.141-3.163-5.69-8.537-5.373-10.207.317-1.671 1.22-.742 1.22 0 0 .107-.005.216-.01.326-.028.655-.06 1.384.866 2.407 1.446 2.46 5.238 3.543 6.186 3.499.268-.013 2.07-.121 3.671-.221.31-.02.208-.07.1-.125-.116-.058-.239-.119.16-.144.087-.006.794-.037 1.708-.077a396.6 396.6 0 0 0 4.557-.212 38.224 38.224 0 0 0 1.517-.151c.436-.05.866-.099 1.278-.132.924-.073 1.615-.089 2.204-.102.596-.013 1.086-.023 1.604-.09 2.817-.36 3.914-.889 4.514-1.358-1.07-.003-3.895-.052-6.55-.463-6.121-.95-9.63-3.617-13.522-7.696-2.866-3.002-4.939-5.44-5.674-6.835-.261-.499.74-1.535 1.213-1.967.687 1.1 2.777 4.287 5.89 7.616 1.955 2.09 3.803 3.817 6.012 5.014.101.056.179.11.254.163.096.066.188.13.32.193.055.027.141.052.224.076.08.024.156.046.201.068.965.48.95.6.937.692-.007.053-.013.097.161.193.093.052.277.045.455.039.152-.006.301-.011.387.02 1.36.493 4.322.897 7.015 1.265 2.055.28 3.953.54 4.864.8l.312.091Zm17.392-9.675c-.7-.128-8.852-1.497-9.468-1.278.353-.396.88-3.347.837-3.567-.043-.22-1.497-.176-2.422.352a2.42 2.42 0 0 1-.347.155c-.502.194-1.07.412-2.175 2.533a7.595 7.595 0 0 1-.36.572c-.354.535-.8 1.21-.79 1.595.003.07.037.12.07.168.04.061.079.118.045.205-.155.388-.364.824-.592 1.3-.415.866-.891 1.86-1.21 2.913 0 0-1.406 2.223-1.054 2.62.352.396 7.756 2.284 7.756 2.284s2.378 1.217 2.797-.033c.172-.519.26-1.236.338-1.867.086-.703.16-1.299.322-1.392.059-.033.24-.04.51-.048.819-.027 2.444-.08 3.875-1.01.194-.125.336-.303.483-.487.085-.106.172-.215.27-.317.05-.05.143-.106.239-.163.113-.068.23-.139.286-.207.114-.142.223-.293.326-.454.792-1.19 1.27-2.579 1.27-2.579s.016-1.11-1.006-1.295Zm-5.235 12.64c-.51-.197-.832-.285-1.226.119-.143.127-.339.396-.392.605-.16.83.153 1.296.91 1.587.617.238 1.322-.17 1.555-.77.261-.685-.124-1.262-.847-1.542Z"
				clipRule="evenodd"
			/>
			<defs>
				<filter
					id="icon_ma_sad_svg__a"
					width={98.001}
					height={98.001}
					x={0}
					y={0}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation={4.5} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.152234 0" />
					<feBlend
						in2="BackgroundImageFix"
						result="effect1_dropShadow_323_2502"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_323_2502"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default MyAccountSad;
